import { CircularProgress } from "@mui/material";

export default function CustomLoader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px" // controls vertical centering area
      }}
    >
      <CircularProgress />
    </div>
  );
}
